/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Null until the workflow reports.
 */
export enum DsaiIngestionPipelineStage {
    INTAKE = 'intake',
    READING = 'reading',
    EXTRACTING = 'extracting',
    RESOLVING = 'resolving',
    IMPORTING = 'importing',
}
